import axios from '@/axios.js'

export default {
  getCashBook (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/cashbook?cashbook_type=${payload}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findCashBook (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/cashbook/${payload.cashbookId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createCashBook (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/cashbook', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCashBook (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/v1/cashbook/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteCashBook (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v1/cashbook/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
